var map = {
	"./taxi_beige.svg": 69995,
	"./taxi_black.svg": 32354,
	"./taxi_blue.svg": 14185,
	"./taxi_brown.svg": 21787,
	"./taxi_green.svg": 56722,
	"./taxi_grey.svg": 94040,
	"./taxi_orange.svg": 39551,
	"./taxi_red.svg": 45874,
	"./taxi_violet.svg": 77916,
	"./taxi_white.svg": 95784,
	"./taxi_yellow.svg": 5337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55401;